export default __webpack_public_path__ + "static/media/IMG_7603 copie copy.51f65079.JPG";